import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from '@core/providers/http';
import { EscalaDocumentoParams } from '@core/models';


@Injectable({ providedIn: 'root' })
export class DocumentEscalaService {
  private readonly endpoint = '/api/Documento/Escala';

  constructor(private readonly apiService: ApiService) {}

  gerarDocumento(params: EscalaDocumentoParams): Observable<Blob> {
    return this.apiService.get<Blob>(
      this.endpoint,
      this.criarParametros(params),
      { responseType: 'blob' },
    );
  }

  criarUrlDownload(params: EscalaDocumentoParams, baseUrl: string): string {
    return `${baseUrl}${this.endpoint}?${this.criarParametros(params).toString()}`;
  }

  private criarParametros(params: EscalaDocumentoParams): HttpParams {
    let httpParams = new HttpParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        httpParams = httpParams.set(key, String(value));
      }
    });
    return httpParams;
  }
}
